export enum CommunicationPreferenceOptions {
  DigitalEmail = 0,
  PostalPhysical = 1,
  NoneSpecified = 2,
}

export interface CommunicationPreferences {
  deliveryChannelNotices?: CommunicationPreferenceOptions;
  deliveryChannelAgm?: CommunicationPreferenceOptions;
  deliveryChannelTra?: CommunicationPreferenceOptions;
  deliveryChannelMembershipCard?: CommunicationPreferenceOptions;
}

export function getEnumValue(value: string): CommunicationPreferenceOptions | undefined {
  return CommunicationPreferenceOptions[value as keyof typeof CommunicationPreferenceOptions];
}

export enum SubscriptionOptIns {
  marketingOptIntype = 'c1b00f98-5744-e911-a96b-000d3ad244fd',
  roadAheadOptInType = '4972e091-e1c1-e811-a95f-000d3ad24c60',
  memberBenefitsOptInType = '0e3a407f-e1c1-e811-a95f-000d3ad24c60',
  researchAndSurveysOptInType = '10d26f68-e1c1-e811-a95f-000d3ad24c60',
  travelOptInType = '009b0f54-5f65-e911-a973-000d3ad24077',
  driveOptInType = 'd271e846-e1c1-e811-a95f-000d3ad24c60',
  roadTripOptInType = '0a76e04c-e1c1-e811-a95f-000d3ad24c60',
}

export interface SubscriptionOptIn {
  id: string;
  preference: boolean;
  typeId: string;
}

export interface SubscriptionType {
  id: string;
  description: string;
  title: string;
  isMemberOnly: boolean;
}

export interface Subscription {
  id: string;
  type: SubscriptionType;
  isOptIn: boolean;
  preference?: string;
  deliveryChannelTra?: string;
}
